export const UPDATE_FILTER_ITEM = 'UPDATE_FILTER_ITEM';
export const REMOVE_FILTER_ITEM = 'REMOVE_FILTER_ITEM';

export const CLEAR_FILTER = 'CLEAR_FILTER';
